// extracted by mini-css-extract-plugin
module.exports = {"contentXarxes":"social_contentXarxes__b_yUI","xarxesHeader":"social_xarxesHeader__ptd7m","social":"social_social__fqa87","iconaSocial":"social_iconaSocial__GJ7ZS"};